export const listItemTheme = {
  baseStyle: {
    container: {
      // listStylePos: 'inside', // change listStylePos to inside
    },
    item: {
      // p: 2, // set padding to 2
      '&::marker': {
        // change color for marker
        color: 'primaryColor',
      },
    },
  },
};
